import React from 'react';
import {Stack} from '@mui/material';
import Header from './Header.js';
import Footer from './Footer.js';

const MainContainer = props=>{
    let {children, headerMargin=4, footerMargin, noHeader} = props;
    return <Stack direction="column">
      {!noHeader&&<Header headerMargin={headerMargin}/>}
      <main>
        {children}
      </main>
      <Footer footerMargin={footerMargin}/>
    </Stack>;
};

export default MainContainer;
